import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { getXmpReport } from '@/api/dashboard/playturbo.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { cookRequestParams } from '@/common/request';

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date(), 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')],
  creative_type: [],
  media_code: [],
  advertiser_id: '',
  advertiser_name: '',
  campaign_id: '',
  adgroup_id: '',
  export: false
};

var defaultGroupBy = ['create_time', 'advertiser_id', 'advertiser_name', 'creative_type', 'media_code'];

export default {
  mixins: [searchMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      },
      media_options: [{
        label: 'other',
        value: 1
      }, {
        label: 'toutiao',
        value: 2
      }, {
        label: 'gdt',
        value: 3
      }, {
        label: 'kuaishou',
        value: 4
      }, {
        label: 'baidu',
        value: 5
      }, {
        label: 'applovin',
        value: 6
      }, {
        label: 'facebook',
        value: 7
      }, {
        label: 'google',
        value: 8
      }, {
        label: 'mintegral',
        value: 9
      }, {
        label: 'tiktok',
        value: 10
      }, {
        label: 'unity',
        value: 11
      }],
      creativeOptions: [{
        label: 'H5',
        value: 'H5'
      }, {
        label: 'font',
        value: 'font'
      }, {
        label: 'video',
        value: 'video'
      }, {
        label: 'image',
        value: 'image'
      }, {
        label: 'audio',
        value: 'audio'
      }, {
        label: 'psd',
        value: 'psd'
      }],
      checkGroups: [].concat(defaultGroupBy),
      checkboxGroup: [{
        label: '日期',
        prop: 'create_time'
      }, {
        label: '广告主ID',
        prop: 'advertiser_id'
      }, {
        label: '广告主名称',
        prop: 'advertiser_name'
      }, {
        label: '投放渠道',
        slot: 'media_code',
        prop: 'media_code'
      }, {
        label: 'Campaign ID',
        prop: 'campaign_id'
      }, {
        label: 'AdGroup ID',
        prop: 'adgroup_id'
      }, {
        label: '素材类型',
        prop: 'creative_type'
      }, {
        label: '素材ID',
        prop: 'fingerprint'
      }, {
        label: '素材名称',
        prop: 'creative_name'
      }, {
        label: '素材一级标签',
        prop: 'creative_first_tag'
      }, {
        label: '素材二级标签',
        prop: 'creative_second_tag'
      }]
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前180天的日期
              disabledDate: function disabledDate(time) {
                var curDate = new Date().getTime();
                var threeMonths = curDate - 180 * 24 * 3600 * 1000;
                return time.getTime() > Date.now() || time.getTime() < threeMonths;
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        },
        creative_type: {
          type: 'select',
          prop: 'creative_type',
          params: {
            placeholder: '素材类型',
            multiple: true,
            'collapse-tags': true,
            clearable: true,
            options: this.creativeOptions
          }
        },
        media_code: {
          type: 'select',
          prop: 'media_code',
          params: {
            placeholder: '投放渠道',
            multiple: true,
            'collapse-tags': true,
            clearable: true,
            options: this.media_options
          }
        },
        advertiser_id: {
          type: 'input',
          prop: 'advertiser_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        advertiser_name: {
          type: 'input',
          prop: 'advertiser_name',
          params: {
            clearable: true,
            placeholder: '请输入广告主名称'
          }
        },
        fingerprint: {
          type: 'input',
          prop: 'fingerprint',
          params: {
            clearable: true,
            placeholder: '请输入素材ID'
          }
        },
        creative_name: {
          type: 'input',
          prop: 'creative_name',
          params: {
            clearable: true,
            placeholder: '请输入素材名称'
          }
        },
        campaign_id: {
          prop: 'campaign_id',
          type: 'input',
          params: {
            placeholder: '请输入Campaign ID',
            clearable: true
          }
        },
        adgroup_id: {
          prop: 'adgroup_id',
          type: 'input',
          params: {
            placeholder: '请输入AdGroup ID',
            clearable: true
          }
        }
      };
      return list;
    },
    basicColumnConfig: function basicColumnConfig() {
      return [{
        label: '花费',
        prop: 'cost'
      }, {
        label: '展示量',
        prop: 'impression'
      }, {
        label: '点击数',
        prop: 'click'
      }, {
        label: '转化数',
        prop: 'conversion'
      }, {
        label: 'CTR',
        prop: 'ctr'
      }, {
        label: 'CVR',
        prop: 'cvr'
      }, {
        label: 'CPM',
        prop: 'cpm'
      }, {
        label: 'CPC',
        prop: 'cpc'
      }, {
        label: 'CPL',
        prop: 'cpl'
      }];
    },
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      var tableList = this.checkboxGroup.filter(function (d) {
        return _this.checkGroups.includes(d.prop);
      }).map(function (d) {
        return _extends({}, d);
      });

      return [].concat(_toConsumableArray(tableList), _toConsumableArray(this.basicColumnConfig));
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.query, {
        created_start_time: this.query.time && this.query.time[0],
        created_end_time: this.query.time && this.query.time[1],
        export: true
      });

      this.checkGroups.forEach(function (item) {
        _Object$assign(params, _defineProperty({}, item + '_group', true));
      });

      delete params.time;

      downloadWithNewWindow(v2Host + '/dashboard/ceditor/xmp-report?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    previewSheet: function previewSheet() {
      window.open('http://cs.mobvista.com:8082/query', '_blank');
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var changeParmas, innerParams, res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                changeParmas = _extends({}, _this2.query, {
                  created_start_time: _this2.query.time && _this2.query.time[0],
                  created_end_time: _this2.query.time && _this2.query.time[1]
                });


                _this2.checkGroups.forEach(function (item) {
                  _Object$assign(changeParmas, _defineProperty({}, item + '_group', true));
                });

                delete changeParmas.time;
                _this2.listLoading = true;
                _context.prev = 4;
                innerParams = _.omit(_.cloneDeep(changeParmas));
                _context.next = 8;
                return getXmpReport(_extends({}, innerParams));

              case 8:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.infos') || []);

                _this2.list = list;
                _this2.pagination.total = _.get(res, 'data.data.total') || 0;
                _this2.listLoading = false;
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](4);

                _this2.listLoading = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 16]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    handleCheckSearch: function handleCheckSearch() {
      this.query.page = 1;
      this.dispatch();
    },
    resetSearch: function resetSearch() {
      this.checkGroups = [].concat(defaultGroupBy);
      this.handleResetSearch();
    },
    getLabel: function getLabel(val) {
      return this.media_options.find(function (item) {
        return item.value === val;
      }).label || '-';
    }
  }
};